import React, { useContext } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { debug, sortObjectsByAlphabet } from "../../utils";
import { useHistory } from "react-router-dom";
import * as urlService from "../../view/urlService";
import { TableContext } from "../../index";

function DeviceTypeField({ deviceTypes = [], selectType, selectedType, setMsbId, setDeviceId }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const onChange = (selectedOption) => {
        const deviceTypeId = selectedOption?.value ?? -1;
        setDeviceId(-1);
        setMsbId(-1);
        selectType(deviceTypeId);

        if (deviceTypeId === -1) {
            setConfig({ ...config, deviceId: -1 });
            const aryFilters = ['device', 'deviceType', 'msb'];
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilters(aryFilters)
            })
            return;
        }

        if (deviceTypes) {
            const deviceType = deviceTypes.find(type => type.id === Number(deviceTypeId));

            if (!deviceType) {
                setConfig({ ...config, deviceId: -1 });
                return;
            }

            history.push({
                pathname: history.pathname,
                search: urlService.replaceFilters('deviceType', deviceType.name)
            })
        }
    }

    const deviceTypeCopy = sortObjectsByAlphabet(deviceTypes, 'name');

    const options = deviceTypeCopy.map(device => ({
        value: device.id,
        label: device.name
    }));

    return (
        <Select
            id="deviceType"
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={options.find(option => option.value === selectedType) || null}
            onChange={onChange}
            options={options}
            isSearchable
            placeholder="Choose"
            noOptionsMessage={() => "No device types available"}
        />
    );
}

function mapStateToProps(state) {
    debug("DeviceTypeField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        deviceTypes: addDeviceModal.deviceTypes
    };
}

export default connect(mapStateToProps)(DeviceTypeField);
